module.exports = __webpack_public_path__ + "images/icon-drag-gallery.ba98d6a4.svg";